import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ContactItem } from "@/store/contacts/interfaces";
import { IPageMeta } from "@/services/interfaces";

@Module({
  name: "contacts",
  namespaced: true,
})
export default class ContactsModule extends VuexModule {
  data: ContactItem[] = [];
  meta: IPageMeta = {};

  get getData() {
    return this.data;
  }

  get getMeta() {
    return this.meta;
  }

  @Mutation
  setContactsPageData(data: any) {
    this.data = data;
  }

  @Mutation
  setContactsMetaData(data: any) {
    this.meta = data;
  }

  @Action
  async requestData(): Promise<void> {
    try {
      const res = await axios({
        method: "GET",
        url: "/api/contacts",
      });

      if (res.data?.data?.items) {
        this.setContactsPageData(res.data?.data?.items);
      }

      if (res.data?.meta) {
        this.setContactsMetaData(res.data?.meta);
      }
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }
}
